import _ from 'lodash'
import iterateEntityWithDisplay from './iterate-entity-with-display'

export default {
  getSideEffects (displayId, menuBlob) {
    const sideEffects = []

    for (let department of _.get(menuBlob, 'departments', [])) {
      iterateEntityWithDisplay(displayId, _.get(department, 'items'), entity => {
        let message = `The Display will be removed from the <strong>KPS Settings</strong> 
                       for the <strong>Item ${entity.info.name}</strong> 
                       in the <strong>Department ${department.info.name}</strong>`
        sideEffects.push(message)
      })
    }

    return sideEffects
  },
  applySideEffects (displayId, menuBlob) {
    for (let department of _.get(menuBlob, 'departments', [])) {
      iterateEntityWithDisplay(displayId, _.get(department, 'items'), entity => {
        const list = entity.kps.displays
        list.splice(list.indexOf(displayId), 1)
      })
    }
  }
}
